// squishy-zoom — click a PDP image to enlarge (lightbox w/ prev/next/esc).
(function(){
  function init(){
    var imgs=[].slice.call(document.querySelectorAll('.pdp-gallery [data-full]'));
    if(!imgs.length)return;
    var ov=document.createElement('div');ov.className='sq-lb';
    ov.innerHTML='<button class="sq-lb-x" aria-label="Close">&times;</button><button class="sq-lb-nav sq-lb-prev" aria-label="Previous">&#8249;</button><img class="sq-lb-img" alt=""><button class="sq-lb-nav sq-lb-next" aria-label="Next">&#8250;</button>';
    document.body.appendChild(ov);
    var big=ov.querySelector('.sq-lb-img'),i=0;
    if(imgs.length<2){ov.querySelector('.sq-lb-prev').style.display='none';ov.querySelector('.sq-lb-next').style.display='none';}
    function show(n){i=(n+imgs.length)%imgs.length;big.src=imgs[i].getAttribute('data-full');}
    function open(n){show(n);ov.classList.add('open');document.body.style.overflow='hidden';}
    function close(){ov.classList.remove('open');document.body.style.overflow='';}
    imgs.forEach(function(im,idx){im.addEventListener('click',function(){open(idx);});});
    ov.addEventListener('click',function(e){
      if(e.target.closest('.sq-lb-next')){show(i+1);return;}
      if(e.target.closest('.sq-lb-prev')){show(i-1);return;}
      if(e.target===ov||e.target.closest('.sq-lb-x'))close();
    });
    document.addEventListener('keydown',function(e){if(!ov.classList.contains('open'))return;
      if(e.key==='Escape')close();else if(e.key==='ArrowRight')show(i+1);else if(e.key==='ArrowLeft')show(i-1);});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();